import CheckoutCotizar from './CheckoutCotizar';
export default CheckoutCotizar;
